import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Send the Save-Data client hint on every API request when the user has enabled
// Data Saver mode. Backend can use this to trim response payloads if desired.
api.interceptors.request.use((config) => {
  if (typeof window !== "undefined") {
    const enabled = localStorage.getItem("tain-data-saver") === "1";
    if (enabled) {
      config.headers = config.headers || {};
      config.headers["Save-Data"] = "on";
    }
  }
  return config;
});

export default api;
